<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs2></v-flex>
      <v-flex xs8>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step step="1"
                            :complete="step > 1">
              Pick up
            </v-stepper-step>
            <v-stepper-step step="2"
                            :complete="step > 2">
              Items
            </v-stepper-step>
            <v-stepper-step step="3"
                            :complete="step > 3">
              Schedule
            </v-stepper-step>
            <v-stepper-step step="4">
              Confirm Cost
            </v-stepper-step>
          </v-stepper-header>
          <connection-manager ref="connectionManager"
                              v-model="connecting">
          </connection-manager>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card>
                <v-card-text>
                  <!--Origin-->
                  <google-place-input
                    id="origin"
                    country="KE"
                    :clearable="false"
                    :courier="true"
                    :disabled="connecting"
                    :enable-geolocation="true"
                    label="Enter pickup location"
                    placeholder="Pickup location"
                    prepend-icon="edit_location"
                    :required="true"
                    :load-google-api="false"
                    :value="originInput"
                    ref="originInput"
                    :hint="originFormattedAddress"
                    persistent-hint
                    :hide-details="false"
                    types='["geocode",]'
                    v-on:placechanged="onOriginEntered">

                  </google-place-input>
                  <v-text-field label="Enter address details"
                                placeholder="Address details E.g. Company Name, Floor name, Contact name, Contact phone"
                                v-model="addressDetails"
                                required
                                :rules="[rules.required]"
                                prepend-icon="edit_location">
                  </v-text-field>
                  <guide text="Please provide location where item or items will be collected"></guide>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat
                         @click.native="onClose(false)"
                         color="red">Cancel
                  </v-btn>
                  <v-btn color="primary"
                         :loading="connecting && !courierOptions.length"
                         :disabled="!originPosition || connecting || invalidForm"
                         @click.native="goStepTwo">
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card-text>
                <!--items-->
                <v-list two-line
                        :style="'max-height: '+($vuetify.breakpoint.height*0.40)+'px; '"
                        class="scroll-y">
                  <template v-for="(item, index) in items">
                    <v-list-tile avatar
                                 @click=""
                                 :key="index">
                      <v-list-tile-avatar>
                        <img :src="$app.imageUrl(item.courierOption.icon)">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="body-2">
                          <b>{{item.quantity}} -
                            {{(item.quantity === 1 ? item.courierOption.name:
                            item.courierOption.pluralName)}}</b>
                          <!-- - {{item.distance/1000}}km-->
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="primary--text caption">
                          <b> To: </b>{{item.destinationName}} -
                          {{item.destinationFormattedAddress}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-menu bottom
                                right
                                offset-y>
                          <v-btn slot="activator"
                                 light
                                 icon>
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list dense>
                            <!--<v-list-tile @click="editItem(item, index)">Edit</v-list-tile>-->
                            <v-list-tile @click="deleteItem(item, index)">Delete</v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index !== items.length - 1"
                               inset
                               :key="index+items.length"></v-divider>
                  </template>
                </v-list>

                <add-delivery-item-dialog :show="addingItem"
                                          @onAddItem="onAddItem"
                                          :courierOptions="courierOptions"
                                          @onClose="addingItem = false">
                </add-delivery-item-dialog>

                <v-btn block
                       :loading="calculatingDirections"
                       flat
                       color="primary"
                       @click.native="addingItem = true, isAnEdit = false"
                       :disabled="connecting || calculatingDirections">
                  <v-icon left
                          dark>add
                  </v-icon>
                  Add item
                  <span slot="loader">Please wait...</span>
                </v-btn>
                <guide text="One/multiple packages with different/same destination"></guide>
              </v-card-text>
              <v-card>
                <v-card-actions>
                  <v-btn flat
                         :disabled="connecting"
                         @click.native="step = 1">
                    <v-icon left>arrow_back</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat
                         :disabled="connecting"
                         @click.native="onClose(false)"
                         color="red">Cancel
                  </v-btn>
                  <v-btn color="primary"
                         :disabled="!items.length"
                         @click.native="step = 3">
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card>
                <v-card-text>
                  <v-layout row
                            wrap>
                    <v-flex xs10
                            offset-xs1>
                      <guide text="We deliver from Monday to Friday between 8 a.m and 4 p.m. And on Saturdays between 8 a.m and 1 p.m"></guide>
                    </v-flex>
                    <v-flex xs8
                            offset-xs2>
                      <v-subheader>Optional scheduling</v-subheader>
                      <date-input v-model="scheduleDate"
                                  :disabled="connecting"
                                  :default-value="currentDate"
                                  placeholder="Pick up date"
                                  :allowedDates="allowedDates">
                      </date-input>
                      <time-input v-model="scheduleTime"
                                  :disabled="connecting"
                                  :default-value="currentTime"
                                  placeholder="pick up time"
                                  :allowedTimes="allowedTimes">
                      </time-input>
                      <v-alert type="error" :value="invalidTime">
                        <p>{{invalidTimeErrorMessage}}</p>
                      </v-alert>
                      <v-alert type="error" :value="invalidDate">
                        <p>Sorry we don't do deliveries of Sundays</p>
                      </v-alert>
                      <guide text="Our rider will pickup your delivery at the earliest time possible"></guide>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions>
                  <v-btn flat
                         :disabled="connecting"
                         @click.native="step = 2">
                    <v-icon left>arrow_back</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat
                         :disabled="connecting"
                         @click.native="onClose(false)"
                         color="red">Cancel
                  </v-btn>
                  <v-btn color="primary"
                         :disabled="connecting || invalidTime || invalidDate"
                         @click.native="step = 4">
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-card>
                <v-card-text>

                  <v-layout row
                            wrap>
                    <v-flex xs8
                            offset-xs2>
                      <v-icon x-large
                              class="mb-3">
                        account_balance_wallet
                      </v-icon>

                      <v-btn block
                             color="primary"
                             outline
                             large
                             flat>
                        Total Cost Estimate: <b>{{$app.formatMoney(estimatedCost)}}</b>
                      </v-btn>
                      <v-checkbox v-model="urgent"
                                  class="mt-3"
                                  :disabled="connecting"
                                  label="This is an urgent delivery">
                      </v-checkbox>
                    </v-flex>
                  </v-layout>

                </v-card-text>
                <v-card-actions>
                  <v-btn flat
                         :disabled="connecting"
                         @click.native="step = 3">
                    <v-icon left>arrow_back</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat
                         :disabled="connecting"
                         @click.native="onClose(false)"
                         color="red">Cancel
                  </v-btn>
                  <v-btn color="primary"
                         :disabled="connecting"
                         @click.native="submit">
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
      <v-flex xs2></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  /* eslint-disable no-undef */

  import GooglePlaceInput from './GooglePlaceInput'
  import EventBus from '../event-bus'
  import Guide from './Guide'
  import ConnectionManager from './ConnectionManager'
  import AddDeliveryItemDialog from './AddDeliveryItemDialog'
  import moment from 'moment'
  import DateInput from './DateInput'
  import TimeInput from './TimeInput'
  import {mapMutations} from 'vuex'

  export default {
    name: 'AddDelivery',
    components: {TimeInput, DateInput, AddDeliveryItemDialog, ConnectionManager, Guide, GooglePlaceInput},
    props: {
      show: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        dialog: false,
        addingItem: false,
        connecting: false,
        step: 1,
        originInput: '',
        originName: null,
        originFormattedAddress: null,
        originVicinity: null,
        originPosition: null,
        isAnEdit: false,
        items: [],
        addressDetails: null,
        courierOptions: [],
        costVariables: [],
        selectedItem: null,
        selectedItemIndex: -1,
        directionsService: new google.maps.DirectionsService(),
        calculatingDirections: false,
        scheduleDate: null,
        // currentDate: moment().format('YYYY-MM-DD'),
        // currentTime: moment().add(1, 'hours').format('HH:mm'),
        allowedDates: {
          dates: function (date) {
            let givenDate = moment(date, 'YYYY/MM/DD')
            if (givenDate.day() === 0) {
              return false
            }
            if (moment().hour() > 15 && moment().hour() < 24) {
              return givenDate.diff(moment(), 'days', true) > 0
            }
            if (moment().isSame(givenDate, 'day')) {
              return true
            }
            return givenDate.diff(moment(), 'days', true) >= 0
          }
        },
        scheduleTime: null,
        urgent: false,
        itemWithLongestDistance: null,
        rules: {
          required: (value) => !!value || 'Required.'
        },
        invalidTimeErrorMessage: 'Pickup time should be between 8a.m and 4p.m and can\'t be lower than the current time'
      }
    },
    computed: {
      invalidTime: function () {
        if (this.scheduleTime) {
          let selectedTime = moment(this.scheduleTime, 'HH:mm')
          let onePM = moment('13:01', 'HH:mm')
          let fourPM = moment('16:01', 'HH:mm')
          let hour = selectedTime.hour()
          if (this.scheduleDate) {
            if (moment(this.scheduleDate, 'YYYY/MM/DD').day() === 6) {
              if (!(hour >= 8 && selectedTime.isBefore(onePM, 'minutes'))) {
                this.invalidTimeErrorMessage = 'Pickup time should be between 8a.m and 1p.m and can\'t be lower than the current time'
                return true
              } else {
                return false
              }
            }
            if (moment().isSame(moment(this.scheduleDate, 'YYYY/MM/DD'), 'day')) {
              if (!(hour >= 8 && selectedTime.isBefore(fourPM, 'minutes') && hour >= (moment().hour() + 1))) {
                this.invalidTimeErrorMessage = 'Pickup time should be between 8a.m and 4p.m and can\'t be lower than the current time'
                return true
              } else {
                return false
              }
            }
          }
          this.invalidTimeErrorMessage = 'Pickup time should be between 8a.m and 4p.m and can\'t be lower than the current time'
          return !(hour >= 8 && hour <= 16)
        } else {
          return false
        }
      },
      invalidDate () {
        if (this.scheduleDate) {
          let selectedDate = moment(this.scheduleDate, 'YYYY/MM/DD')
          return selectedDate.day() === 0
        } else {
          return false
        }
      },
      currentDate () {
        if (moment().hour() > 15 && moment().hour() < 24) {
          return moment().add(1, 'days').format('YYYY-MM-DD')
        }
        return moment().format('YYYY-MM-DD')
      },
      currentTime () {
        if (moment().hour() === 7) {
          return moment().add(1, 'hours').format('HH:mm')
        } else if (moment().hour() > 15 && moment().hour() < 24) {
          return moment('08:00', ['HH:mm'], true).format('HH:mm')
        } else if (moment().hour() >= 24 && moment().hour() < 7) {
          return moment('08:00', ['HH:mm'], true).format('HH:mm')
          // return moment().add(1, 'hours').format('HH:mm')
        }
        return moment().add(1, 'hours').format('HH:mm')
      },
      estimatedCost () {
        if (this.items.length > 0) {
          let timeCost = 0
          let distanceCost = 0
          let baseCost = 0
          let totalCost = 0
          // calculate the longest distance of the trip
          let estimatedMaxDistance = 0
          for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i]
            if (item.distance > estimatedMaxDistance) {
              estimatedMaxDistance = item.distance
              this.itemWithLongestDistance = item
            }
            // the code below can be improved
            let distance = item.distance / 1000
            let duration = item.duration / 60
            if (this.urgent) {
              if (item.courierOption.id === 3) {
                distanceCost = this.costVariables.ERRAND_COST_PER_KM * distance
                timeCost = this.costVariables.ERRAND_COST_PER_MIN * duration
                baseCost = this.costVariables.ERRAND_BASE_COST
              } else {
                distanceCost = this.costVariables.URGENT_COST_PER_KM * distance
                timeCost = this.costVariables.URGENT_COST_PER_MIN * duration
                baseCost = this.costVariables.URGENT_BASE_COST
              }
            } else {
              if (item.courierOption.id === 3) {
                distanceCost = this.costVariables.ERRAND_COST_PER_KM * distance
                timeCost = this.costVariables.ERRAND_COST_PER_MIN * duration
                baseCost = this.costVariables.ERRAND_BASE_COST
              } else {
                distanceCost = this.costVariables.NON_URGENT_COST_PER_KM * distance
                timeCost = this.costVariables.NON_URGENT_COST_PER_MIN * duration
                baseCost = this.costVariables.NON_URGENT_BASE_COST
              }
            }
            this.$app.log('distance: ' + distance)
            this.$app.log('duration: ' + duration)
            this.$app.log('distanceCost: ' + distanceCost)
            this.$app.log('timeCost: ' + timeCost)
            this.$app.log('baseCost: ' + baseCost)
            let itemTotalCost = baseCost + timeCost + distanceCost
            itemTotalCost += (item.stops.length * 30)
            let totalInclusiveProfitMargin = 1.6 * itemTotalCost
            let valueAddedTax = 0.16 * totalInclusiveProfitMargin
            itemTotalCost = totalInclusiveProfitMargin + valueAddedTax
            if (this.urgent) {
              if (itemTotalCost < this.costVariables.URGENT_MIN_COST) {
                itemTotalCost = this.costVariables.URGENT_MIN_COST
              }
            } else {
              if (itemTotalCost < this.costVariables.NON_URGENT_MIN_COST) {
                itemTotalCost = this.costVariables.NON_URGENT_MIN_COST
              }
            }
            this.items[i].itemTotalDeliveryCost = itemTotalCost
            totalCost += itemTotalCost
          }
          return totalCost
        }
        return 0
      },
      invalidForm: function () {
        return !this.addressDetails
      },
      allowedTimes () {
        return {
          hours: function (value) {
            if (this.scheduleDate) {
              if (this.scheduleDate.day() === 6) {
                return value >= 8 && value <= 13 && value >= (moment().hour() + 1)
              }
              if (moment().isSame(this.scheduleDate, 'day')) {
                return value >= 8 && value <= 16 && value >= (moment().hour() + 1)
              }
            }
            return value >= 8 && value <= 16
            // return value >= moment().hour()
          },
          minutes: function (value) {
            return value % 15 === 0
          }
        }
      }
    },
    watch: {
      show (val) {
        this.dialog = !!val
      },
      originPosition (val) {
        if (this.items.length > 0) {
          let itemsCopy = [...this.items]
          this.items = []
          for (let item of itemsCopy) {
            this.onAddItem(item)
          }
        }
        this.$app.log(JSON.stringify(val))
      }
    },
    methods: {
      ...mapMutations({
        setSelectedItem: 'setSelectedItem'
      }),
      onOriginEntered (addressData, placeResultData) {
        this.originFormattedAddress = placeResultData.formatted_address
        this.originVicinity = placeResultData.vicinity
        this.originName = placeResultData.name
        this.originPosition = {
          lat: placeResultData.geometry.location.lat(),
          lng: placeResultData.geometry.location.lng()
        }
        EventBus.$emit('onOriginChanged', this.originPosition)
      },
      onClose (successful) {
        this.step = 1
        this.originPosition = null
        this.originFormattedAddress = null
        this.originVicinity = null
        this.note = null
        this.urgent = false
        this.scheduleDate = null
        this.scheduleTime = null
        this.items = []
        this.itemWithLongestDistance = null
        this.addingItem = false
        this.isAnEdit = false
        this.$refs.originInput.clear()
        this.$emit('onClose', successful)
      },
      onAddItem (item, isAnEdit) {
        this.addingItem = false
        this.isAnEdit = false
        this.calculatingDirections = true
        let that = this
        let waypts = []
        for (let stop of item.stops) {
          waypts.push({
            location: stop.stop_formatted_address,
            stopover: true
          })
        }
        this.directionsService.route({
          origin: this.originPosition.lat + ',' + this.originPosition.lng,
          destination: item.destinationPosition.lat + ',' + item.destinationPosition.lng,
          waypoints: waypts,
          optimizeWaypoints: false,
          travelMode: 'DRIVING'
        }, function (result, status) {
          that.$app.log(result)
          if (status === 'OK') {
            item.distance = 0
            item.duration = 0
            for (let leg of result.routes[0].legs) {
              item.distance = item.distance + leg.distance.value
              item.duration = item.duration + leg.duration.value
            }
            // if (that.originPosition.lat === item.destinationPosition.lat && that.originPosition.lng === item.destinationPosition.lng) {
            //   item.distance = item.distance * 2
            // }
            that.items.push(item)
            that.calculatingDirections = false
            that.$app.log('The total distance is: ' + JSON.stringify(item))
          } else {
            that.$app.log('Directions request failed due to ' + status)
          }
        })
      },
      editItem (item, index) {
        this.setSelectedItem(item)
        this.selectedItem = item
        this.selectedItemIndex = index
        this.addingItem = true
        this.isAnEdit = true
      },
      deleteItem (item, index) {
        this.items.splice(index, 1)
      },
      submit () {
        this.error = false
        let deliveryItems = []
        let estimatedCost = Math.ceil(this.estimatedCost)
        for (let item of this.items) {
          deliveryItems.push({
            destinationName: item.destinationName,
            destinationVicinity: item.destinationVicinity,
            destinationFormattedAddress: item.destinationFormattedAddress,
            destinationLatitude: item.destinationPosition.lat,
            destinationLongitude: item.destinationPosition.lng,
            estimatedDistance: item.distance,
            estimatedDuration: item.duration,
            stops: item.stops,
            note: item.note,
            itemTotalDeliveryCost: item.itemTotalDeliveryCost,
            recipientContact: item.recipientContact,
            recipientName: item.recipientName,
            quantity: item.quantity,
            courierOptionId: item.courierOption.id
          })
        }
        this.$app.log(JSON.stringify(deliveryItems))
        let that = this
        this.$refs.connectionManager.post('/deliveries', {
          onSuccess (response) {
            that.onClose(true)
            EventBus.$emit(that.$actions.addedDelivery)
            that.$app.log(response)
            const filter = 'pendingApproval'
            that.$router.push({name: 'courier', params: {filter}})
          }
        }, {
          urgent: this.urgent,
          originName: this.originName,
          addressDetails: this.addressDetails,
          originVicinity: this.originVicinity,
          originFormattedAddress: this.originFormattedAddress,
          originLatitude: this.originPosition.lat,
          originLongitude: this.originPosition.lng,
          scheduleDate: this.scheduleDate,
          scheduleTime: this.scheduleTime,
          estimatedCost: estimatedCost,
          estimatedMaxDistance: this.itemWithLongestDistance.distance,
          estimatedMaxDuration: this.itemWithLongestDistance.duration,
          items: deliveryItems,
          maintenance: 'maintenance'
        })
      },
      goStepTwo () {
        if (!this.courierOptions.length) {
          let that = this
          // Load courier options
          this.$refs.connectionManager.get('/courierOptions', {
            onSuccess (response) {
              that.$app.log(response.data.data)
              that.$app.log(response.data.variables)
              that.costVariables = response.data.costVariables
              that.courierOptions = that.courierOptions.concat(response.data.data)
              that.step = 2
            }
          }, {withCostVariables: true})
        } else {
          this.step = 2
        }
      }
    },
    mounted () {
      this.scheduleTime = this.currentTime
      this.scheduleDate = this.currentDate
      EventBus.$on('onOriginChanged', (payload) => {

      })
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AddDelivery.vue